<div class="tw-flex tw-justify-center tw-p-2.5">
  <ngb-datepicker
    #dp
    class="v-dp"
    (dateSelect)="onDateSelection($event)"
    [displayMonths]="displayMonth()"
    [dayTemplate]="t"
    outsideDays="hidden"
    [minDate]="minDate()!"
    [maxDate]="maxDate()!"
  >
  </ngb-datepicker>
  <ng-template
    #t
    let-date
    let-currentMonth="currentMonth"
    let-focused="focused"
  >
    <span
      class="v-dp-day"
      [class.focused]="focused"
      [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)"
      [class.text-muted]="isOutside(date, currentMonth)"
      [class.outside]="isOutside(date, currentMonth)"
      (mouseenter)="hoveredDate.set(date)"
      (mouseleave)="hoveredDate.set(null)"
    >
      {{ date.day }}
    </span>
    <span
      class="v-dp-lunar-day"
      [class.text-muted]="isOutside(date, currentMonth)"
      [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)"
    >
      @if (isToday(date)) {
        <div class="v-dp-today">
          <span>{{ date | lunarDay }}</span>
          <span>Hôm nay</span>
        </div>
      } @else {
        <div class="v-dp-today">
          {{ date | lunarDay }}
        </div>
      }
    </span>
  </ng-template>
</div>
